<section class="gpx-route">
  <h3 class="gpx-route__title ci-heading-h3-s-bold">
    {{ 'Datos de la ruta' | translate }}
  </h3>
  
  <div class="gpx-route__content">
    <div 
      class="gpx-route__stats-elevation"
      [class.only-waypoints]="!(gpxData() && gpxElevation())"
    >
      <app-stats 
        [gpxStatsData]="gpxStats()"
      />
      
      <app-details-gpx-elevation 
        [elevationData]="gpxElevation()" 
      />
    </div>

    <app-details-gpx-map 
      [class.only-waypoints]="!(gpxData() && gpxElevation())" 
      [gpxData]="gpxData()"
      [coordinates]="mapCoordinates"
      (elevationProfileEmitter)="handleReceivedElevation($event)"
    />
  </div>

</section>